import React, { useCallback } from "react";
import clsx from "clsx";

import Button from "../../../components/common/Button/Button";
import * as NavigationUtils from "../../../lib/util/NavigationUtils";
import { link } from "../../../lib/util/NavigationUtils";
import Logo from "../../../components/custom/Logo/Logo";
import * as UserSelectors from "../../../store/User/User.selector";
import { useSelector } from "../../../lib/hook/ReduxHooks";

export interface SplashNavProps {
	noInteraction?: boolean;
}

const SplashNav = (props: SplashNavProps) => {
	const { noInteraction } = props;

	const { isUserLoggedIn, loggedInUser } = useSelector((state) => ({
		loggedInUser: UserSelectors.selectLoggedInUser(state),
		isUserLoggedIn: UserSelectors.selectLoggedInUser(state)?.uid,
	}));

	const handleReturn = useCallback(
		(e: React.MouseEvent) => {
			link(isUserLoggedIn ? "/home" : "/login", e);
		},
		[isUserLoggedIn],
	);

	return (
		<div
			className={clsx("Nav", "SplashNav", {
				"--unfixed": noInteraction,
			})}
		>
			<div className={"SplashNav__content"}>
				<Logo
					noClickThrough={noInteraction}
					href={isUserLoggedIn ? "/home" : NavigationUtils.LANDING_PAGE_URL}
				/>
				{!noInteraction && (
					<div>
						{isUserLoggedIn && <p>Welcome back, {loggedInUser?.firstName}</p>}
						<Button className={"--invert --white"} onClick={handleReturn}>
							{isUserLoggedIn ? "Dashboard" : "Sign In"}
						</Button>
					</div>
				)}
			</div>
		</div>
	);
};

export default SplashNav;
